export default __webpack_public_path__ + "static/media/accounthub-icon.9353042f.png";